<div class="timer-container">
  <countdown [config]="{ leftTime: countdownTimeSec, format: 'mm:ss', notify: [notifySec] }" (event)="handleEvent($event)"></countdown>
</div>
